import { gql } from '@apollo/client'

export const generateInstantLoginToken = gql`
  mutation GenerateInstantLoginToken($telephone: String!, $date_of_birth: String!, $sgh: String!, $email: String) {
    generateInstantLoginToken(telephone: $telephone, date_of_birth: $date_of_birth, sgh: $sgh, email: $email) {
      token
      emails
    }
  }
`